import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://xcelitsolutions.co.uk/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.message === 'Login successful') {
        // Store logged-in state
        localStorage.setItem('isLoggedIn', 'true');
        // Store user object as JSON string
        localStorage.setItem('userC', JSON.stringify(data.user));
        // Navigate to home page
        navigate('/home');
      } else {
        alert(data.message || 'Login failed');
      }
    } catch (error) {
      alert('Error: ' + error.message);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: 'auto', padding: '20px' }}>
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <div>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: '100%', marginBottom: '10px' }}
          />
        </div>
        <div>
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: '100%', marginBottom: '10px' }}
          />
        </div>
        <button type="submit" style={{ padding: '10px 20px' }}>
          Login
        </button>
      </form>
      <p style={{ marginTop: '15px' }}>
        Don’t have an account?{' '}
        <button
          onClick={() => navigate('/register')}
          style={{ color: 'blue', border: 'none', background: 'none', cursor: 'pointer' }}
        >
          Register here
        </button>
      </p>
      <p>
        <button
          onClick={() => navigate('/forgot-password')}
          style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer' }}
        >
          Forgot Password?
        </button>
      </p>
    </div>
  );
}

export default Login;
